<template>
    <div>
        <solicitacoes-reaberturas
            :solicitacoesReaberturas="solicitacoesReaberturas"
            :solicitacoesReaberturasServicos="
                obterSolicitacoesReaberturasServicos()
            "
            :permiteAprovar="false"
            :permiteReprovar="false"
            :statusPadrao="-1"
            perfil="gestor"
            @atualizar-status-selecionado="statusSelecionado = $event"
            @atualizar-listagem="obterSolicitacoesReaberturas()"
        >
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('CRED-GEST-ENTR-00')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar Entrega"
                        @click.stop="detalharEntrega(data.entregaId)"
                    ></i>
                </span>
            </template>
        </solicitacoes-reaberturas>
        <router-view></router-view>
    </div>
</template>

<script>
import SolicitacoesReaberturasServicos from './SolicitacoesReaberturasServicos'
import SolicitacoesReaberturas from '../../componentes/solicitacoesReaberturas/SolicitacoesReaberturas'

export default {
    components: {
        SolicitacoesReaberturas
    },
    data() {
        return {
            solicitacoesReaberturas: [],
            statusSelecionado: 0
        }
    },
    methods: {
        obterSolicitacoesReaberturas() {
            this.$store.dispatch('addRequest')
            SolicitacoesReaberturasServicos.obterTodas(
                this.statusSelecionado
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.solicitacoesReaberturas = response.data
                    } else {
                        this.erros = [
                            'Erro ao obter as solicitações de reaberturas'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterSolicitacoesReaberturasServicos() {
            return SolicitacoesReaberturasServicos
        },

        detalharEntrega(entregaId) {
            let routeData = this.$router.resolve({
                name: 'Gestores_Entregas_Detalhar',
                params: {
                    entregaId: entregaId
                }
            })
            window.open(routeData.href, '_blank')
        }
    },

    created() {
        this.obterSolicitacoesReaberturas()
    },

    computed: {},

    watch: {
        statusSelecionado() {
            this.obterSolicitacoesReaberturas()
        }
    }
}
</script>
